import { Check, Minus, Zap, Bike } from "lucide-react";

const ROWS_EV = [
  ["Laadstops op maat van jouw EV", true, false, true, false],
  ["Dag-per-dag planning met hotels & activiteiten", true, false, false, false],
  ["Budget & laadkosten — raming én werkelijk", true, false, false, false],
  ["Kosten verdelen met reisgenoten — wie betaalt wie", true, false, false, true],
  ["Reisdagboek met foto's, video & voice", true, true, false, false],
  ["Familie volgt live mee & reageert met emoji's", true, true, false, false],
  ["Reactie-melding per e-mail + direct antwoorden", true, false, false, false],
  ["AI-reisassistent & AI-reisverslag", true, false, false, false],
  ["GPX import & export", true, false, true, false],
  ["Paklijst & EV-checklist op maat", true, false, false, false],
];

const ROWS_MOTO = [
  ["Bochtige routes met bochtigheids-score", true, false, true, false],
  ["Tankstops op maat van jouw moto", true, false, false, false],
  ["Dag-per-dag planning met hotels & activiteiten", true, false, false, false],
  ["Budget & benzinekosten — raming én werkelijk", true, false, false, false],
  ["Kosten verdelen met reisgenoten — wie betaalt wie", true, false, false, true],
  ["Reisdagboek met foto's, video & voice", true, true, false, false],
  ["Familie volgt live mee & reageert met emoji's", true, true, false, false],
  ["AI-reisassistent & AI-reisverslag", true, false, false, false],
  ["GPX import & export", true, false, true, false],
  ["Paklijst & moto-checklist op maat", true, false, false, false],
];

const Cell = ({ v, highlight, accent }) => (
  <td className="py-4 text-center">
    {v ? (
      <span className={`inline-flex w-6 h-6 rounded-full items-center justify-center ${highlight ? accent.checkBg : "bg-white/10"}`}>
        <Check className={`w-3.5 h-3.5 ${highlight ? accent.checkText : "text-white/70"}`} />
      </span>
    ) : (
      <Minus className="w-4 h-4 text-white/25 inline" />
    )}
  </td>
);

const ACCENTS = {
  ev: { pill: "bg-[#74C69D]/15 border-[#74C69D]/30 text-[#74C69D]", checkBg: "bg-[#74C69D]/20", checkText: "text-[#74C69D]", Icon: Zap },
  moto: { pill: "bg-[#38BDF8]/15 border-[#38BDF8]/30 text-[#38BDF8]", checkBg: "bg-[#38BDF8]/20", checkText: "text-[#38BDF8]", Icon: Bike },
};

export const ComparisonTable = ({ mode = "ev" }) => {
  const rows = mode === "moto" ? ROWS_MOTO : ROWS_EV;
  const cols = mode === "moto" ? ["Polarsteps", "Calimoto", "Tricount"] : ["Polarsteps", "ABRP", "Tricount"];
  const accent = ACCENTS[mode] || ACCENTS.ev;
  return (
    <div data-testid="comparison-table" className="overflow-x-auto rounded-3xl border border-white/10 bg-white/[0.03]">
      <table className="w-full min-w-[660px] text-sm">
        <thead>
          <tr className="border-b border-white/10">
            <th className="text-left py-5 pl-6 font-normal text-white/50 text-xs tracking-wider uppercase">Wat krijg je?</th>
            <th className="py-5 px-3 w-32">
              <span className={`inline-flex items-center gap-1.5 rounded-full border px-3.5 py-1.5 font-bold ${accent.pill}`}>
                <accent.Icon className="w-3.5 h-3.5" /> VoltRoute
              </span>
            </th>
            {cols.map((c) => (
              <th key={c} className="py-5 px-3 w-28 font-semibold text-white/60">{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(([label, vr, a, b, c], i) => (
            <tr key={label} className={i < rows.length - 1 ? "border-b border-white/5" : ""}>
              <td className="py-4 pl-6 pr-4 text-white/85">{label}</td>
              <Cell v={vr} highlight accent={accent} />
              <Cell v={a} accent={accent} />
              <Cell v={b} accent={accent} />
              <Cell v={c} accent={accent} />
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
